import { render, staticRenderFns } from "./EditPurchasePage.vue?vue&type=template&id=5eb39ae6&scoped=true&"
import script from "./EditPurchasePage.vue?vue&type=script&lang=ts&"
export * from "./EditPurchasePage.vue?vue&type=script&lang=ts&"
import style0 from "./EditPurchasePage.vue?vue&type=style&index=0&id=5eb39ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb39ae6",
  null
  
)

export default component.exports